module.exports = __webpack_public_path__ + "img/bg-4.1.3bd0e558.jpg";